export function filterArrOfObjByMultipleKeys(array, filterObj) {
	// Convert array filter values to Sets for faster lookup
	const optimizedFilters = Object.entries(filterObj).reduce((acc, [key, value]) => {
		acc[key] = Array.isArray(value) ? new Set(value) : value;
		return acc;
	}, {});
	return array.filter((item) =>
		Object.entries(optimizedFilters).every(([key, filterValue]) => {
			if (filterValue instanceof Set) {
				if (filterValue.size) return filterValue.has(item[key]);
				else return true;
			}
			return item[key] === filterValue;
		})
	);
}
